import React, { useState, useEffect, forwardRef } from 'react'
import { DatePicker } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import type { DatePickerProps } from 'antd'

export interface AntdDateProps extends Omit<DatePickerProps, 'onChange' | 'value'> {
  value?: string
  onChange?: (value: string) => void
  name?: string
  placeholder?: string
  className?: string
  disabled?: boolean
  allowClear?: boolean
  size?: 'large' | 'middle' | 'small'
  min?: string
}

const AntdDate = forwardRef<any, AntdDateProps>(
  ({ 
    value, 
    onChange, 
    name, 
    placeholder = "DD-MMM-YYYY", 
    className = "",
    disabled = false,
    allowClear = true,
    size = 'middle',
    ...props 
  }, ref) => {

    const handleDatePickerChange = (date: Dayjs | null) => {
      if (date) {
        const formattedDate = date.format('YYYY-MM-DD')
        if (onChange) {
          onChange(formattedDate)
        }
      } else {
        if (onChange) {
          onChange('')
        }
      }
    }
    return (
      <div className="relative w-full">
        <DatePicker
          className={`w-full h-10 rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background
            file:border-0 file:bg-transparent file:text-sm file:font-medium
            placeholder:text-muted-foreground
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
            disabled:cursor-not-allowed disabled:opacity-50
            [&.ant-picker-focused]:border-2 [&.ant-picker-focused]:border-blue-600
            [&.ant-picker-outlined:focus]:border-2 [&.ant-picker-outlined:focus]:border-blue-600
            hover:border-gray-300
            [&_.ant-picker-input]:bg-transparent
            [&_.ant-picker-input]:text-gray-900
            [&_.ant-picker-input]:placeholder:text-gray-500
            ${className}`}
          format="DD-MMM-YYYY"
          value={value ? dayjs(value) : null}
          onChange={handleDatePickerChange}
          placeholder={placeholder}
          disabled={disabled}
          allowClear={allowClear}
          size={size}
          ref={ref}
          inputReadOnly={true}
          {...props}
        />
      </div>
    )
  }
)

AntdDate.displayName = "AntdDate"

export { AntdDate } 